import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { UserManagementApiService } from './user-management-api.service';
import { UserResult } from '../model/user-management.model';

@Injectable()
export class UserManagementService {
  readonly #userManagementApiService = inject(UserManagementApiService);

  public loadUsers(query?: string): Observable<UserResult[]> {
    return this.#userManagementApiService.getUsers(query);
  }
}
